// create audience api
import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getAnswerResult: {
    method: 'GET',
    url: `${configs.baseUrl}/api/answer-result`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getAnswerResult = async (presentationId, participantId) => {
  const res = await resource.getAnswerResult({ audienceId: participantId, presentationId })
  return res.body
}

export default {
  initResource,
  getAnswerResult,
}
